module.exports = __webpack_public_path__ + "img/newt5.b13a5350.png";